import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './index.css';

const CommonModal = ({
  show,
  handleClose,
  title,
  footer,
  showButtonText=false,
  size = 'sm',
  leftMargin = '0',
  showCustomHeader = false,
  children,
  conditionalClass = '',
  showfooter = true,
  handleCustomBackButton
}: any) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      className={`dialog_section ${conditionalClass}`}
      size={size}
      style={{ marginLeft: leftMargin }}
      backdrop={'static'}
    >
      {showCustomHeader ? (
        <div
          className='customModal_header'
        >
          <div
            className="d-flex align-items-center modal-back-button"
            onClick={handleCustomBackButton}
            data-testid='back-button'
          >
            <i className="bi bi-arrow-left"></i>
            {showButtonText && <span style={{color:"#A9328D",cursor:"pointer"}}>Back</span>}
          </div>
          <div
            className="d-flex align-items-center modal-back-button"
            onClick={handleClose}
            data-testid='close-button'
          >
            <i className="bi bi-x"></i>
            {showButtonText && <span style={{color:"#D53E3E",cursor:"pointer"}}>Discard</span>}
          </div>
        </div>
      ) : <Modal.Header closeButton>
        {title && <Modal.Title>{title}</Modal.Title>}
      </Modal.Header>}


      <Modal.Body>{children}</Modal.Body>
      {showfooter && <Modal.Footer>
        {footer ? (
          footer
        ) : (
          <>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleClose}>
              Save Changes
            </Button>
          </>
        )}
      </Modal.Footer>}
    </Modal>
  );
};
export default CommonModal;
